import React, { useEffect, useState, useCallback } from "react";
import { useOutletContext } from "react-router-dom";
import { Header } from "../components/Sidebar";
import { StatusBadge } from "../components/StatusBadge";
import api from "../lib/api";
import { formatGs } from "../lib/format";
import { Coins } from "lucide-react";

export default function Cod() {
  const { setMobileOpen } = useOutletContext();
  const [envios, setEnvios] = useState([]);
  const load = useCallback(() => { api.get("/envios?modalidad=cod").then(({ data }) => setEnvios(data.filter((e) => e.status === "entregado"))).catch(() => {}); }, []);
  useEffect(() => { load(); }, [load]);

  const pendientes = envios.filter((e) => !e.liquidado);
  const liquidados = envios.filter((e) => e.liquidado);
  const totalPend = pendientes.reduce((s, e) => s + (e.valor_producto || 0), 0);

  const Row = ({ e }) => (
    <tr className="hover:bg-slate-50/60">
      <td className="px-4 py-3 font-mono font-bold text-xs">{e.code}</td>
      <td className="px-4 py-3">{e.remitente_nombre || "—"}</td>
      <td className="px-4 py-3 text-right font-semibold">{formatGs(e.valor_producto)}</td>
      <td className="px-4 py-3"><StatusBadge status={e.status} /></td>
      <td className="px-4 py-3 text-xs">{e.liquidado ? <span className="text-emerald-600 font-semibold">Liquidado</span> : <span className="text-amber-600 font-semibold">Pendiente</span>}</td>
    </tr>
  );

  return (
    <>
      <Header title="COD" subtitle="Cobros contra entrega y liquidación a remitentes" onMenu={() => setMobileOpen(true)} />
      <main className="p-4 sm:p-6 lg:p-8 space-y-6">
        <div className="bg-white rounded-xl border border-[#E2E8F0] p-5 shadow-sm flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="h-11 w-11 rounded-xl bg-amber-50 border border-amber-200 flex items-center justify-center"><Coins className="h-5 w-5 text-[#F5A623]" /></div>
            <div><div className="text-xs text-[#64748B] uppercase">Pendiente de liquidar</div><div className="text-2xl font-extrabold text-[#0A1F44]">{formatGs(totalPend)}</div></div>
          </div>
        </div>
        <div className="bg-white rounded-xl border border-[#E2E8F0] shadow-sm overflow-hidden">
          <div className="px-4 py-3 border-b border-slate-100 font-semibold text-[#0A1F44]">Envíos COD entregados</div>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-slate-50 text-[#64748B] text-xs uppercase"><tr><th className="text-left font-semibold px-4 py-3">Código</th><th className="text-left font-semibold px-4 py-3">Remitente</th><th className="text-right font-semibold px-4 py-3">Valor producto</th><th className="text-left font-semibold px-4 py-3">Estado</th><th className="text-left font-semibold px-4 py-3">Liquidación</th></tr></thead>
              <tbody className="divide-y divide-slate-100">
                {pendientes.map((e) => <Row key={e.id} e={e} />)}
                {liquidados.map((e) => <Row key={e.id} e={e} />)}
                {envios.length === 0 && <tr><td colSpan={5} className="px-4 py-10 text-center text-[#64748B]">No hay envíos COD entregados.</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </>
  );
}
